import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const listPlaceholders = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/placeholder`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
        data: filter,
    });
    return res;
};

export const getPlaceholder = async (placeholderDefinitionId) => {
    let res = false;
    if (placeholderDefinitionId !== '0') {
        res = await r({
            endpoint: `${keeper('apiUrl')}/v2/placeholder/${placeholderDefinitionId}`,
            sessionToken: keeper('sessionToken'),
            method: 'get',
        });
    }
    return res;
};

export const configureImageCodeImageModel = (placeholder) => {
    switch (placeholder.sample[0].imageCodeType) {
        case 'QRCODE_PAYMENT':
            return {
                barcode: {
                    type: 'PAYMENT',
                    account: placeholder.sample[0].imageCodeAccount,
                    amount: placeholder.sample[0].imageCodeAmount,
                    currency: placeholder.sample[0].imageCodeCurrency,
                    vs: placeholder.sample[0].imageCodeVs,
                    ss: placeholder.sample[0].imageCodeSs,
                    ks: placeholder.sample[0].imageCodeKs,
                    message: placeholder.sample[0].imageCodeMessage,
                    dateTs: placeholder.sample[0].imageCodeDateTs,
                },
                barcodeType: placeholder.sample[0].imageCodeBarcodeType,
                width: placeholder.sample[0].imageCodeWidth,
                height: placeholder.sample[0].imageCodeHeight,
            };
        case 'QRCODE_TEXT':
            return {
                barcode: {
                    type: 'TEXT',
                    text: placeholder.sample[0].imageCodeText,
                },
                barcodeType: placeholder.sample[0].imageCodeBarcodeType,
                width: placeholder.sample[0].imageCodeWidth,
                height: placeholder.sample[0].imageCodeHeight,
            };
        case 'QRCODE_URL':
            return {
                barcode: {
                    type: 'URL',
                    url: placeholder.sample[0].imageCodeUrl,
                },
                barcodeType: placeholder.sample[0].imageCodeBarcodeType,
                width: placeholder.sample[0].imageCodeWidth,
                height: placeholder.sample[0].imageCodeHeight,
            };
        default:
            return {
                barcode: {
                    type: 'TEXT',
                    text: placeholder.sample[0].imageCodeText,
                },
                barcodeType: placeholder.sample[0].imageCodeBarcodeType,
                width: placeholder.sample[0].imageCodeWidth,
                height: placeholder.sample[0].imageCodeHeight,
            };
    }
};

export const getImageCodeImage = async (placeholder) => {
    let res = false;
    res = await r({
        endpoint: `${keeper('apiUrl')}/v2/barcode/generate`,
        sessionToken: keeper('sessionToken'),
        method: 'post',
        data: configureImageCodeImageModel(placeholder),
        responseType: 'blob',
    });
    return res;
};

export const savePlaceholder = async (placeholderDefinitionId, placeholder, saving = {}) => {
    let method = 'put',
        endpoint = `${keeper('apiUrl')}/v2/placeholder/${placeholderDefinitionId}`,
        searchEndpoint = '/v2/placeholder/{placeholderId}';

    if (placeholderDefinitionId === '0') {
        method = 'post';
        searchEndpoint = '/v2/placeholder';
        endpoint = `${keeper('apiUrl')}/v2/placeholder`;
    }

    const dataModel = await normalizeBySchema(searchEndpoint, method, placeholder);

    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    saving.active = false;
    return res;
};

export const usePlaceholders = async () => {
    return {
        listPlaceholders: listPlaceholders,
        getPlaceholder: getPlaceholder,
        getImageCodeImage: getImageCodeImage,
        savePlaceholder: savePlaceholder,
    };
};

export default usePlaceholders;
